import { z } from 'zod';

import type { StartProactiveConversationRequest } from '@nucleus-commerce/api-client/admin';

/** Same limit as a reply (the API's MAX_MESSAGE_LENGTH). */
export const START_CHAT_MAX_LENGTH = 4000;

/** The "Start chat" dialog: the first message, and a department or the store's default. */
export const startChatFormSchema = z.object({
  body: z
    .string()
    .trim()
    .min(1, { error: 'conversations:startChat.validation.bodyRequired' })
    .max(START_CHAT_MAX_LENGTH, { error: 'conversations:startChat.validation.bodyLength' }),
  /** Empty for the store's default department. */
  departmentId: z.string(),
});

export type StartChatForm = z.infer<typeof startChatFormSchema>;

export const emptyStartChatForm = (): StartChatForm => ({ body: '', departmentId: '' });

export const toStartChat = (values: StartChatForm): StartProactiveConversationRequest => ({
  body: values.body,
  ...(values.departmentId ? { departmentId: values.departmentId } : {}),
});
